import { ITextValueOption } from '@waseel-asp/tpa-waseel-lib-staging';
import { ICommonAutoComplete } from "../../../../../shared/models/common-models";

interface IAddress {
  addressId: string;
  countryId: string;
  stateId: string;
  cityId: string;
  countryNameEnglish?: string;
  countryNameArabic?: string;
  stateNameArabic?: string;
  stateNameEnglish?: string;
  cityNameArabic?: string;
  cityNameEnglish?: string;
  street: string;
  addressLine: string;
  zipcode: string;
  latitude: string;
  longitude: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string;
  deletedDate: string;
}

interface IContact {
  contactId: string;
  telephone: string;
  mobileNumber: string;
  contactNumber: string;
  emergencyNumber: string;
  fax: string;
  email: string;
  website: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string;
  deletedDate: string;
}

interface IBankAccount {
  bankAccountId: string;
  nameEnglish: string;
  nameArabic: string;
  accountNumber: string;
  bankAccountName: string;
  iban: string;
  countryNameEnglish?: string;
  countryNameArabic?: string;
  stateNameArabic?: string;
  stateNameEnglish?: string;
  cityNameArabic?: string;
  cityNameEnglish?: string;
  countryId: string;
  stateId: string;
  cityId: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string;
  deletedDate: string;
}

export interface IInsuranceCompany {
  companyId: string;
  companyCode: string;
  nameEnglish: string;
  nameArabic: string;
  mohLicenseNumber: string;
  crNo: string;
  crExpiryDate: string;
  vatRegistrationNumber: string;
  cchiId: string;
  cchiExpiryDate: string;
  nphiesId: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy: string;
  deletedDate: string;
  address: IAddress;
  contact: IContact;
  bankAccount: IBankAccount;
  waseelPayerId: string;
  payerURL: string;
  insuranceCompanyContacts?: InsuranceCompanyContact[];
  erpCompanyId?: string;
}

export interface InsuranceCompanyContact {
  insuranceCompanyContactId: string,
  personDetailId: string,
  nameEnglish: string,
  nameArabic: string,
  payerStaffRoleId: string,
  payerStaffRoleNameEnglish?: string,
  payerStaffRoleNameArabic?: string,
  personalEmail: string,
  personalMobile: string,
  email: string,
  mobile: string
}

export const insuranceCompanyConfig = {
  entityName: 'INSURANCE_COMPANY.TITLE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  crNo: 'FORM_FIELD.CR_NUMBER',
  mohLicenseNumber: 'FORM_FIELD.MOH_LICENSE_NUMBER',
  vatRegistrationNumber: 'FORM_FIELD.VAT_REGISTRATION_NUMBER',
  cchiId: 'FORM_FIELD.CCHI_ID',
  nphiesId: 'FORM_FIELD.NPHIES_ID',
  payerUrl: 'FORM_FIELD.PAYER_URL',
  mobileNumber: 'FORM_FIELD.MOBILE_NO',
  telephone: 'FORM_FIELD.TELEPHONE',
  contactNumber: 'FORM_FIELD.CONTACT_NUMBER',
  emergencyNumber: 'FORM_FIELD.EMERGENCY_NUMBER',
  email: 'FORM_FIELD.EMAIL',
  website: 'FORM_FIELD.WEBSITE',
  fax: 'FORM_FIELD.FAX',
  street: 'FORM_FIELD.STREET',
  zipcode: 'FORM_FIELD.ZIPCODE',
  latitude: 'FORM_FIELD.LATITUDE',
  longitude: 'FORM_FIELD.LONGITUDE',
  countryId: 'COMMON.COUNTRY',
  stateId: 'COMMON.STATE',
  cityId: 'FORM_FIELD.CITY',
  bankAccountName: 'FORM_FIELD.CUSTOMER_NO',
  accountNumber: 'FORM_FIELD.ACCOUNT_NO',
  iban: 'FORM_FIELD.IBAN',
  crExpiryDate: 'FORM_FIELD.CR_EXPIRY_DATE',
  cchiExpiryDate: 'FORM_FIELD.CCHI_EXPIRY_DATE',
  companyCode: 'FORM_FIELD.COMPANY_CODE',
  waseelPayerId: 'FORM_FIELD.WASEEL_PAYER_ID',
  personalEmail: 'FORM_FIELD.PERSONAL_EMAIL',
  personalMobile: 'FORM_FIELD.PERSONAL_Mobile',
  payerStaffRoleId: 'ENTITY_TYPE_LIST.PAYER_STAFF_ROLE',
  addInsuranceCompanyContact: 'COMMON.ADD_CONTACT_STAFF',
  editInsuranceCompanyContact: 'COMMON.EDIT_CONTACT_STAFF'
};

export interface insuraceCompanyDropDownConfig {
  // single/multiple select, lazy loading, auto-complete, or direct dropdown. 
  label?: string,
  formControlName: string,
  allowSearching: boolean,
  allowMultiple: boolean,
  showAllOptions: boolean,
  enableLazyLoading: boolean,
  isAutoComplete: boolean,
  loadDataFromApi: boolean,
  allowClear: boolean,
  pageSize?: number,
  userPayerOnly?: boolean,
  selectedOptions: ITextValueOption[] | ICommonAutoComplete[],
  dropdownOptions?: ITextValueOption[] | ICommonAutoComplete[],
  selectionChange?(data: ITextValueOption | ITextValueOption[] | ICommonAutoComplete | ICommonAutoComplete[]): void;
  clearInputCallBack?(event: KeyboardEvent): void;
  disable?: boolean,
}
